// extracted by mini-css-extract-plugin
export default {"donateBtn":"donateButton_donateBtn__9D8up","donateBtnGrid":"donateButton_donateBtnGrid__qCmdW","donateIcon":"donateButton_donateIcon__O3U8-"};